import { SITE_PAGES } from "../data/site";
import type { CompanyRegistration } from "../data/legalRegistrations";

/**
 * Always real and unconditional — every field is either a fixed brand fact
 * (name) or derived from data already published elsewhere on the site
 * (SITE_PAGES' own homepage description, the one logo asset that exists).
 * Deliberately omits `sameAs`: Footer's social links are all `href="#"`
 * placeholders, and asserting those as real profile URLs here would be the
 * same class of fabrication this project has consistently declined to do
 * (see pressMentions.ts, caseStudies.ts).
 */
export function buildOrganizationSchema(origin: string): Record<string, unknown> {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "ZenFresh",
    url: origin,
    logo: `${origin}/logo.png`,
    description: SITE_PAGES[0].description,
  };
}

/**
 * Gated on real company registration data existing — see
 * legalRegistrations.ts, currently always null. Returns null (no schema
 * emitted) until then, same pattern as CompanyRegistrationBlock.tsx's own
 * PostalAddress schema; activates automatically with zero code change once
 * COMPANY_REGISTRATION is populated.
 */
export function buildLocalBusinessSchema(
  origin: string,
  registration: CompanyRegistration | null
): Record<string, unknown> | null {
  if (!registration) return null;

  return {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: registration.legalName,
    url: origin,
    address: {
      "@type": "PostalAddress",
      streetAddress: registration.registeredAddress,
    },
  };
}
